module.exports = __webpack_public_path__ + "static/media/banner-mobile-apple-non-ppfa@3x.ca25f289.png";